export const Events: Record<string, string> = {
  'asset.created': 'created a new asset',
  'asset.duplicated': 'duplicated an asset',
  'asset.updated': 'updated an asset',
  'asset.deleted': 'deleted an asset',
  'asset.moved': 'moved an asset',
  'asset.restored': 'restored an asset',
  'asset.trashed': 'trashed an asset',
  'asset.undeleted': 'undeleted an asset',
  'asset.note.added': 'added note to an asset',
  'asset.note.deleted': 'deleted asset note',
  'asset.note.undeleted': 'undeleted asset note',
  'asset.note.updated': 'updated asset note',
  'comment.deleted': 'deleted a comment',
  // The private/public word and the body come from the audit details, so this
  // entry is only the stem — see AuditLogItem.
  'comment.privacy.updated': 'made a comment',
  'asset.version.activated': 'activated version of asset',
  // Hard coding for now to meet the requirements, will be changed when we refactor audit logs
  'asset.version.updated': 'updated the focal point of the asset',
  'asset.version.created': 'created a new version of asset',
  'asset.version.deleted': 'deleted version of asset',
  'album.assets.added': 'added assets into album',
  'album.assets.reordered': 'reordered assets into album',
  'album.assets.removed': 'removed assets from album',
  'album.created': 'created an album',
  'album.updated': 'updated an album',
  'album.deleted': 'deleted an album',
  'album.moved': 'moved an album',
  'album.restored': 'restored an album',
  'album.trashed': 'trashed an album',
  'album.undeleted': 'undeleted an album',
  'folder.created': 'created a folder',
  'folder.updated': 'updated a folder',
  'folder.deleted': 'deleted a folder',
  'folder.moved': 'moved a folder',
  'folder.restored': 'restored a folder',
  'folder.trashed': 'trashed a folder',
  'folder.undeleted': 'undeleted a folder',
  'metadata.created': 'created metadata',
  'metadata.updated': 'updated metadata',
  'metadata.deleted': 'deleted metadata',
  'trash.emptied': 'emptied the trash',
  'version.created': 'created a new version',
  'variant.created': 'created a new variant',
  'variant.updated': 'updated a variant',
  'variant.deleted': 'deleted a variant',
  'destination.created': 'created a new destination',
  'destination.updated': 'updated a destination',
  'destination.deleted': 'deleted a destination',
  'tag.created': 'created a new tag',
  'tag.updated': 'updated a tag',
  'tag.deleted': 'deleted a tag',
  'tag.moved': 'moved a tag',
  'workflow.created': 'created a new workflow',
  'workflow.updated': 'updated a workflow',
  'workflow.deleted': 'deleted a workflow',
  'workflow.status.created': 'created a new workflow status',
  'workflow.status.updated': 'updated a workflow status',
  'workflow.status.deleted': 'deleted a workflow status',
  'workflow.status.undeleted': 'undeleted a workflow status',
  'node.share.created': 'created a new share',
  'node.share.updated': 'updated a share',
  'node.share.deleted': 'deleted a share',
  'user.created': 'created a new user',
  'user.updated': 'updated a user',
  'user.deleted': 'deleted a user',
};

export const ShareAuditEvents = ['node.share.created', 'node.share.updated'] as const;

export type ShareAuditEvent = (typeof ShareAuditEvents)[number];

export const isShareAuditEvent = (event: string): event is ShareAuditEvent =>
  (ShareAuditEvents as ReadonlyArray<string>).includes(event);

export type EventSuffix =
  | 'renamed'
  | 'created'
  | 'duplicated'
  | 'updated'
  | 'deleted'
  | 'moved'
  | 'restored'
  | 'trashed'
  | 'undeleted'
  | 'activated'
  | 'added'
  | 'reordered'
  | 'removed'
  | 'unknown';
